export default __webpack_public_path__ + "static/media/InvoiceDoc.07c035c7.graphql";